import {RoleDto} from "../../services/klaraApi";
import Enumerable from "linq";

export default function checkPermission(permissionName: string, roles: Array<RoleDto>) {
    return Enumerable.from(roles).any(role => role.isAdmin || Enumerable.from(role.rolePermissions).any(p => p.permissionName === permissionName && p.value === "Allow"));
}